/* eslint-disable react/no-multi-comp */
import { TranslationService } from '@/utils/services/TranslationService';

// Hooks
import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { PLATFORM_OPTIONS } from '@/lib/routes/privateRoutes';

import H3 from '@/components/base/Headings/H3';
import Loader from '@/components/base/Loader';
// Layout
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
// Components
import { PlatformForm } from '@/components/pages/settings/platform/PlatformForm';
import { Trans } from '@/components/tools/translation';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';

const PageContent = () => {
    const { isLoading: isUserLoading } = useUser();

    return (
        <SettingsWrapper>
            <SettingsWrapper.MainContent>
                {isUserLoading ? (
                    <div className="flex min-h-72 items-center justify-center">
                        <Loader className="h-8 w-8 text-icoBlue" />
                    </div>
                ) : (
                    <PlatformForm />
                )}
            </SettingsWrapper.MainContent>
            <SettingsWrapper.SideContent>
                <SideContent />
            </SettingsWrapper.SideContent>
        </SettingsWrapper>
    );
};

const SideContent = () => {
    const { t } = useTranslation('settings');

    return (
        <div className="p-8 xl:px-7 xl:py-10">
            <H3 className="mb-m">
                <Trans i18nKey="settings:platform_page.setup_translation" />
            </H3>
            <p className="font-GSemiBold text-xs leading-4 text-icoGray-500 dark:text-icoDarkMode-wolf">
                {t('platform_page.settings_platform_col_text')}
            </p>
        </div>
    );
};

export const getServerSideProps =
    TranslationService.getTranslationMessagesFromRoute(PLATFORM_OPTIONS);

export default function Platform() {
    return (
        <WrapperSwitchLayout noPadding={true} disableMainScroll={true}>
            <PageContent />
        </WrapperSwitchLayout>
    );
}
